export const brokerAEVFields = {
    isForeignLocation: {
        name: "is_foreign_location",
        label: "Foreign Location",
        required: true,
    },
    isNcoa: {
        name: "is_ncoa",
        label: "NCOALink Service",
        required: true,
    },
    isDsf: {
        name: "is_dsf",
        label: "DSF2 Service",
        required: true,
    },
    isTriplex: {
        name: "is_triplex",
        label: "Triplex",
        required: true,
    },
    isWaiverOnFile: {
        name: "is_waiver_on_file",
        label: "NCOALink 7-Day Fulfillment Waiver on File",
        required: true,
    },
    isInternal: {
        name: "is_internal",
        label: "Internal",
        required: true,
    },
    brokerId: {
        name: "listadmin_id",
        label: "Broker Id",
        required: false,
    },
    brokerSid: {
        name: "listadmin_sid",
        label: "Broker SID",
        required: false,
    },
    brokerType: {
        name: "listadmin_type",
        label: "Broker Type",
        required: false,
    },
    companyName: {
        name: "company_name",
        label: "Company Name",
        required: true,
    },
    address1: {
        name: "address1",
        label: "Address 1",
        required: true,
    },
    address2: {
        name: "address2",
        label: "Address 2",
        required: false,
    },
    city: {
        name: "city",
        label: "City",
        required: true,
    },
    state: {
        name: "state",
        label: "State",
        required: true,
    },
    postalCode: {
        name: "postal_code",
        label: "Zip",
        required: true,
    },
    urbanization: {
        name: "urbanization",
        label: "Urbanization",
        required: false,
    },
    federalTaxId: {
        name: "federal_tax_id",
        label: "Federal Tax Id",
        required: false,
    },
    naicsCode: {
        name: "naics_code",
        label: "NAICS Code",
        required: true,
    },
    representativeName: {
        name: "representative_name",
        label: "Representative Name",
        required: true,
    },
    representativeTitle: {
        name: "representative_title",
        label: "Representative Title",
        required: false,
    },
    representativeEmail: {
        name: "representative_email",
        label: "Representative Email",
        required: true,
    },
    companyWebsite: {
        name: "company_website",
        label: "Company Website",
        required: false,
    },
    phone: {
        name: "phone",
        label: "Telephone",
        required: true,
    },
    notes: {
        name: "notes",
        label: "Notes",
        required: false,
    },
    isDeleted: {
        name: "is_deleted",
        label: "Is Deleted",
        required: true,
    },
    createDatetime: {
        name: "create_datetime",
        label: "Create at",
        required: false,
    },
    modifyDatetime: {
        name: "modify_datetime",
        label: "Modified at",
        required: false,
    },
    modifyUserId: {
        name: "modify_user_id",
        label: "Modified By Id",
        required: false,
    },
    modifyUserName: {
        name: "modify_user_name",
        label: "Modified By",
        required: false,
    },
}


